/* @flow */

import React from 'react';
import { Menu, Button } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import PlatformSelector
  from 'catalog/screens/shared/components/PlatformSelector';
import PageTemplateLabel
  from 'catalog/screens/shared/components/PageTemplateLabel';
import SecurityButton from './SecurityButton';

type Props = {
  page: CatalogPage,
  platform: CatalogPlatform,
  platforms: Array<CatalogPlatform>,
  isDisabled: boolean,
  isUpdating: boolean,
  onUpdate: () => void,
  onChangePlatform: (platform: CatalogPlatform) => void,
};

const PageHeader = ({
  page,
  platform,
  platforms,
  isDisabled,
  isUpdating,
  onUpdate,
  onChangePlatform,
}: Props) => (
  <Menu>
    <Menu.Item>
      <Link to="/" className="ui basic labeled icon button">
        <i className="chevron circle left icon" />
        Retour à la liste
      </Link>
    </Menu.Item>
    <Menu.Item className="borderless">
      <PageTemplateLabel page={page} />
    </Menu.Item>
    <Menu.Menu position="right">
      {!page.template.isLocked &&
        <Menu.Item className="borderless">
          <SecurityButton page={page} />
        </Menu.Item>}
      {platforms.length > 1 &&
        <Menu.Item className="borderless">
          <PlatformSelector
            value={platform}
            platforms={platforms}
            onChange={onChangePlatform}
          />
        </Menu.Item>}
      <Menu.Item>
        <Button
          onClick={onUpdate}
          loading={isUpdating}
          disabled={isDisabled}
          primary
          icon="save"
          content="Enregistrer"
          labelPosition="right"
        />
      </Menu.Item>
    </Menu.Menu>
  </Menu>
);

export default PageHeader;



// WEBPACK FOOTER //
// ./src/modules/catalog/screens/Page/Edit/components/PageHeader.js